var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrackTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.025,
    height: 42.344,
    viewBox: "0 0 37.025 42.344",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_522",
    "data-name": "Group 522",
    transform: "translate(-145.597 -53.202)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_491",
    "data-name": "Path 491",
    d: "M177.2,63.945h0c-.052-.052-.1-.1-.156-.1l1.408-1.721a.4.4,0,0,0-.052-.522l-1.825-1.512a.4.4,0,0,0-.522.052l-1.408,1.669a18.124,18.124,0,0,0-8.552-3.181V56.279h2.242V53.2h-8.448v3.077h2.242v2.347A18.518,18.518,0,1,0,177.2,63.945ZM175.375,88.3a15.9,15.9,0,1,1,4.679-11.266A15.9,15.9,0,0,1,175.375,88.3Z",
    transform: "translate(0 0)",
    fill: "#444141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_29",
    "data-name": "Union 29",
    d: "M6.127,6.128h0v0h0v0Z",
    transform: "translate(158.329 70.624)",
    fill: "#444141"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_29_-_Outline",
    "data-name": "Union 29 - Outline",
    d: "M22573.67-8284.562h-1.887v-5.185h-5.182v-1.886h5.182v-5.184h1.887v5.184h5.184v1.886h-5.184Z",
    transform: "translate(-22408.275 8367.439)",
    fill: "#444141"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackTimeIcon);
export default __webpack_public_path__ + "static/media/TrackTimeIcon.a92cb4dfafd1eccce04e148e58296855.svg";
export { ForwardRef as ReactComponent };